import { Unit } from '@src/types';
import { Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import styles from './OverviewForm.module.scss';
import WarningIcon from 'src/assets/icons/warning-red1.svg?react';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { IconClock, IconBrain, IconGrade } from '@src/constants';

type Props = {
  isGroupOnboarding?: boolean
  unit?: any
};

const defaultRequirement = 'This Lesson requires the Teacher Key, which contains additional information that is necessary to teach the Lesson. Please download this document and have it available while running the Lesson.';

function OverviewForm(props: Props) {
  const { unit, isGroupOnboarding = false } = props;

  const [box1, setBox1] = useState<string[]>([]);
  const [box2, setBox2] = useState<string[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [skillsHeading, setSkillsHeading] = useState('This Unit teaches skills for:');
  const [helpfulHeading, setHelpfulHeading] = useState('This Unit is helpful for students who:');
  const [requirement, setRequirement] = useState('This Lesson requires the Teacher Key, which contains additional information that is necessary to teach the Lesson. Please download this document and have it available while running the Lesson.')
  const [requirementVisible, setRequirementVisible] = useState(false)
  const [competency, setCompetency] = useState<string[]>([]);
  const [isNewCover, setIsNewCover] = useState(false);

  useEffect(() => {
    if (unit) {
      setTags(JSON.parse(unit?.tags || '[]'));
      setBox1(JSON.parse(unit?.box1 || '[]'));
      setBox2(JSON.parse(unit?.box2 || '[]'));
      setSkillsHeading(unit?.skillsHeading || 'This Unit teaches skills for:');
      setHelpfulHeading(unit?.helpfulHeading || 'This Unit is helpful for students who:');
      setRequirement(unit.description || 'This Lesson requires the Teacher Key, which contains additional information that is necessary to teach the Lesson. Please download this document and have it available while running the Lesson.')
      setRequirementVisible(unit.requirementVisible);
      setCompetency(JSON.parse(unit.competency || '[]').join(', '));
      setIsNewCover(unit?.isNewCover);
    }
  }, [unit])

  const isHEA = (unit as Unit)?.teacherPreparation === undefined

  return (
    <div>
      <div className={styles.wrapper}>
        {isGroupOnboarding ? null : (
          <div className={styles.contentView}>
            {isNewCover ? <>
              <div className={styles.infoContent}>
                <LordIcon
                  src={IconGrade}
                  isHover={true} 
                  colors={{
                    primary: '#274649',
                    secondary: '#274649'
                  }}
                  size={20}
                  target='.OverviewForm_infoContent__htEWS'
                />
                <div className={styles.tagLabel}>Lessons: </div><span>{unit?.classPresentation?.length || ""}</span>
              </div>
              <div className={styles.infoContent}>
                <LordIcon
                  src={IconClock}
                  isHover={true} 
                  colors={{
                    primary: '#274649',
                    secondary: '#274649'
                  }}
                  size={20}
                  target='.OverviewForm_infoContent__htEWS'
                />
                <div className={styles.tagLabel}>Suggested Pace: </div>
                <span>{unit?.pace}</span>
              </div>
              {competency && <div className={styles.infoContent}>
                <LordIcon
                  src={IconBrain}
                  isHover={true} 
                  colors={{
                    primary: '#274649',
                    secondary: '#274649'
                  }}
                  size={20}
                  target='.OverviewForm_infoContent__htEWS'
                />
                <div className={styles.tagLabel}>Competency: </div>
                <span>{competency}</span>
              </div>}
            </> : <>
              <div className={styles.subContent}><span>Number of Lessons:</span><div style={{color: 'black'}}> {unit?.classPresentation?.length}</div></div>
              <div className={styles.subContent}><span>Suggested Pace: </span><div style={{color: 'black'}}>{unit?.pace}</div></div>
              {isHEA ? null : competency ? <div className={styles.subContent}><span>Competency: </span><div style={{color: 'black'}}>{competency}</div></div> : null}
              {unit?.sensitive && <div className={styles.sensitiveView}>
                <div className={styles.sensitiveButton}>{'SENSITIVE CONTENT'}
                  <Tooltip
                    placement='topLeft'
                    title={<div className={styles.sensitiveTooltipText}>
                      {unit?.sensitiveTooltip ?? 'This Unit contains sensitive content. We recommend previewing the lessons to ensure you are comfortable with material.'}
                    </div>}
                    arrowPointAtCenter
                    color='#FFFFFF'>
                    <WarningIcon className={styles.rightTipIcon}/>
                  </Tooltip>
                </div>
              </div>}
            </>}
          </div>
        )}
        {isGroupOnboarding ? null : (
          <div className={styles.contentView}>
            <div className={styles.header}>
              <div className={styles.subTitle}>
                At a Glance:
              </div>
            </div>
            <div className={styles.tagView}>
            {(tags ?? []).map((o, index) => {
              const optionStr: string = o as string;
              return (
                <div key={index} className={styles.tagBox}>
                  {optionStr}
                </div>
              );
            })}
            </div>
          </div>
        )}
      </div>
      <div className={styles.wrapper}>
        <div className={styles.contentView}>
          <div className={styles.header}>
            <div className={styles.subTitle}>
              {skillsHeading}
            </div>
          </div>
          <ul className={styles.boxView}>
          {(box1 ?? []).map((o, index) => {
            const optionStr: string = o as string;
            return (
              <li key={index} className={styles.questionBox}>
                {optionStr}
              </li>
            );
          })}
          </ul>
        </div>
        
        <div className={styles.contentView}>
          <div className={styles.header}>
            <div className={styles.subTitle}>
              {helpfulHeading}
            </div>
          </div>
          <ul className={styles.boxView}>
          {(box2 ?? []).map((o, index) => {
            const optionStr: string = o as string;
            return (
              <li key={index} className={styles.questionBox}>
                {optionStr}
              </li>
            );
          })}
          </ul>
        </div>
      </div>
      {requirementVisible && <>
        <div className={styles.requirementTitle}>Required Materials</div>
        <div className={styles.requirementContent}>
        { defaultRequirement === requirement ? <div className={styles.requirementText}>
            <strong>Note: This Lesson requires the Teacher Key, which contains additional information that is necessary to teach the Lesson. Please download this document and have it available while running the Lesson.</strong>
          </div> : <div className={styles.requirementText}>
            <strong>Note:</strong>&nbsp;{requirement}
          </div>}
        </div>
      </>}
    </div>
  );
}

export default OverviewForm;